import ApiApp from '@/api/app';
import auth from '@/utils/auth';
import utils from '@/utils/utils';


const state = {
  username: localStorage.getItem('loginUser') || '先生/女士',
  staffCode: localStorage.getItem('staffCode'),
  hasKongZhiTai: '', // 是否有控制台权限
  dictionary: [],
  buttonList: [],
};
const getters = {
  hasKongZhiTai: state => state.hasKongZhiTai,
  dictionary: state => state.dictionary,
  buttonList: state => state.buttonList,
};
const mutations = {
  saveName(state, res) {
    localStorage.setItem('loginUser', res.name);
    localStorage.setItem('staffCode', res.staffCode);
    state.username = res.name;
    state.staffCode = res.staffCode;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_BUTTONLIST: (state, buttonList) => {
    state.buttonList = buttonList;
  },
  SET_DICTIONARY: (state, dictionary) => {
    state.dictionary = dictionary;
  },
  setKongZhiTai: (state, hasKongZhiTai) => {
    state.hasKongZhiTai = hasKongZhiTai;
  },
};
const actions = {
  GetInfo({ commit }, token) {
    const params = {
      accessToken: token,
      param: '14', // 根据产品填写对应id
    };
    return new Promise((resolve, reject) => {
      ApiApp.reqLoginPosSystemPrivileges(params)
        .then(res => {
          auth.setItem('roles', res.result.children);
          commit('SET_ROLES', res.result.children);
          auth.setItem('buttonList', res.result.buttonList);
          commit('SET_BUTTONLIST', res.result.buttonList);
          resolve(res.result);
        }).catch(error => {
          reject(error);
        });
    });
  },
  GetDictionary({ commit }) {
    return new Promise((resolve, reject) => {
      // 系统id
      ApiApp.reqLoginPostDictionaryBySystem({}, `/${2101}`)
        .then(res => {
          const dictionary = utils.formatDictionary(res.result);
          commit('SET_DICTIONARY', dictionary);
          auth.setItem('dictionary', dictionary);
          console.log('字典表获取完毕：');
          console.log(dictionary);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
    });
  },
  GetStaffInfo({ commit }, code) {
    return new Promise((resolve, reject) => {
      ApiApp.reqStaffInfo({}, code)
        .then(res => {
          commit('saveName', res.result);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
